import React  from 'react';

//*MUI
import { Avatar , Box , Divider , List  , ListItemButton , ListItemIcon , ListItemText , Link  } from '@mui/material';
import ListItem  , { listItemClasses }   from '@mui/material/ListItem';
import { makeStyles } from '@mui/styles';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import cssClasses from "./sidebar.module.css";
import { signout } from "../../services/Auth";
import { useSelector } from 'react-redux';
import Tooltip from '@mui/material/Tooltip';


//*Sidebar Icons
import HomeIcon from "../../assets/images/Sidebar-Icons/icons/home.svg";
import MyExams from "../../assets/images/Sidebar-Icons/icons/myExams.svg";
import admitCards from "../../assets/images/Sidebar-Icons/icons/AdmitCards.svg";
import student from "../../assets/images/Sidebar-Icons/icons/profile.png";
import AStudent from "../../assets/images/Sidebar-Icons/active Icons/AProfile.png";
import ActiveMyExams from "../../assets/images/Sidebar-Icons/active Icons/AExams.svg";
import ActiveHome from "../../assets/images/Sidebar-Icons/active Icons/Ahome.svg";
import ActiveHallTicket from "../../assets/images/Sidebar-Icons/active Icons/hall-tickets-active.svg";
import { errorToast, successToast } from '../../services/Toast';

const useStyles = makeStyles((theme) => ({
    listItemText : {
        margin: "0",
        "& span": {
            display: "inline-block",
            fontFamily: "Inter-Medium",
            fontSize: "1.6rem",
            lineHeight: "2.4rem",
            color: "#344054",
            fontWeight:500,
            textTransform: 'capitalize',
        },
    }, 
    active: {
        background: "#000",
        color: "#6941C6",
        "& span": {
            color: "#6941C6",
        },
    }, 
    menu_item: {
        marginBottom: "0.8rem",
        "&:hover": {
            background: "#6941C6",
            color: "#344054",
        }
    },  
}));

const sidebarMenuList = [
    {
        title: "Home",
        TabName:"home",
        link: "/home/",
        icon : HomeIcon,
        activeIcon: ActiveHome,
    },
    {
        title: "Profile",
        TabName :"profile",
        link: "/home/profile",
        icon : student , 
        activeIcon: AStudent,
    },
    {
        title: "My Exam",
        TabName :"exams",
        link: "/home/exams",
        icon : MyExams,
        activeIcon: ActiveMyExams,
    },
    {
        title: "Admit Cards",
        TabName :"admit-cards",
        link: "/home/admit-cards",
        icon :admitCards,
        activeIcon: ActiveHallTicket,
    },    
]

function Sidebar() {
    const loggedInUser = useSelector((state) => state.Auth.user);
    const activeMenu = useSelector((state) => state.ActiveMenu.activeMenu);

    const classList = useStyles();
    const navigate = useNavigate();

    function logOut() {
        signout().then(res=>{
            successToast("Logged Out!")
            navigate("/");
        }).catch(err =>{
          console.log(err);
          errorToast(err.toString());
        })
    }


    const KeyLogoutPressed = (e) => {
        if (e.key === 'Enter') {
            logOut();
        }
      };

    return (
        <div style={{height: "100%" }}>
            <Divider />
            <Box style={{height: 'calc(100% - 5px)',display: 'flex',flexDirection: 'column',justifyContent: 'space-between'}}>
                <List sx={{[` & .${listItemClasses.root}:hover`]: {
                    backgroundColor: "#F4EBFF",
                   },
                  }}>
                    {sidebarMenuList.map((menuItem, index) => (
                         
                     <Link to={menuItem.link} key={`MenuArray_${index}`}  >
                    <ListItem button key={menuItem.title} disablePadding  className={classList.menu_item} classes={{ selected: classList.active }}
                    selected={activeMenu  === menuItem.TabName}>  
                        <ListItemButton onClick={() => {navigate(menuItem.link)}} >
                            <ListItemIcon >
                            <img  src={activeMenu === menuItem.TabName? menuItem.activeIcon : menuItem.icon} alt={menuItem.name} />
                            </ListItemIcon>
                            <ListItemText primary={menuItem.title} className={classList.listItemText} />
                        </ListItemButton>
                       
                    </ListItem>
                    </Link>
              
                    ))}  
                </List>
               
                <List>  
                  <Divider />
                    <ListItem className={cssClasses.logoutWrapper}>
                        <Avatar alt={""} src={loggedInUser?.profilePicture} />
                        <div className={cssClasses.NameDiv}>
                            <p className={cssClasses.headerTitle}>{loggedInUser ? loggedInUser['Full Name'] : ""}</p>
                            <p className={cssClasses.subTitle}>{loggedInUser?.email}</p>
                        </div>
                        <Tooltip title={<h1 className={cssClasses.logoutTitle}>Logout</h1>} tabIndex="0" >
                        <div onClick={logOut} onKeyPress={KeyLogoutPressed} style={{flex: 'unset' ,   cursor: "pointer" }}>
                            <LogoutIcon  style={{width: "2.4rem", height: "2.4rem" , color:"#667085" }}/>  
                        </div>
                        </Tooltip>
                    </ListItem>
                </List>
                
            </Box>
        </div>
    )
}

export default Sidebar